import React, { Component } from "react";
import { PAGE_HEADERS } from "../util/Constants";
import PageHeader from "../PageHeader";
import LabsSkeleton from "./LabsSkeleton";

class Labs extends Component {
  render() {
    return (
      <div>
        <PageHeader {...PAGE_HEADERS.LABS} />
        <LabsSkeleton />
      </div>
    );
  }
}

export default Labs;



// WEBPACK FOOTER //
// ./src/components/labs/Labs.js